  // Bouton back-to-top
  const backToTop = document.querySelector(".back-to-top");

  function smoothScroll() {
    window.scrollTo({
        top: 0, 
        behavior: 'smooth'
    });
  }

  function showBackToTop() {
    const scrollTop = document.documentElement.scrollTop;

    if( scrollTop > 800) {
      backToTop.classList.add('back-to-top--visible');
    } else {
      backToTop.classList.remove('back-to-top--visible');
    }
  };

  backToTop.addEventListener('click', function() {
    smoothScroll();
  })

  window.onscroll = function() {
    showBackToTop();
  }